"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOutboundCostsByUsagePercentage = exports.averageZip3CostsToZip2 = exports.getWeightKey = exports.getWeightTier = exports.getOutboundShippingCostByZip2 = void 0;
const _ = require("lodash");
function getOutboundShippingCostByZip2(warehouseId, outboundCostData, demand, weightKey, outboundCostFallback = 0) {
    const sumZip3Cost = (zip3) => {
        const summedCost = _.sumBy(_.values(outboundCostData), (dayCost) => {
            const zip3Cost = dayCost.costs[warehouseId][weightKey][zip3] || outboundCostFallback;
            return dayCost.usagePercentage * zip3Cost;
        });
        return summedCost;
    };
    return averageZip3CostsToZip2(demand, sumZip3Cost);
}
exports.getOutboundShippingCostByZip2 = getOutboundShippingCostByZip2;
function getWeightTier(product, dimensionalWeightFactor = 237, maxWeightTier = 32, minWeightTier = 1) {
    if (!product || !product.weight || !product.width || !product.length || !product.height) {
        return 1;
    }
    const shippingWeight = Math.max((product.length * product.width * product.height) / dimensionalWeightFactor, product.weight);
    return Math.min(maxWeightTier, shippingWeight > 1 ? Math.ceil(shippingWeight) : minWeightTier);
}
exports.getWeightTier = getWeightTier;
function getWeightKey(weight) {
    return Number.isInteger(weight) ? weight.toFixed(1) : weight.toString();
}
exports.getWeightKey = getWeightKey;
function averageZip3CostsToZip2(demand, zip3Cost) {
    return _(demand)
        .entries()
        .groupBy(([zip3]) => zip3.slice(0, 2))
        .mapValues((pairs) => {
        let result = _.sum(pairs.map(([zip3, d]) => d * zip3Cost(zip3))) / _.sum(pairs.map(([, d]) => d));
        if (!result) {
            result = 0;
        }
        return result;
    })
        .value();
}
exports.averageZip3CostsToZip2 = averageZip3CostsToZip2;
function createOutboundCostsByUsagePercentage(outboundCosts, sellerConfig) {
    if (outboundCosts.length === 0) {
        return {};
    }
    if (_.difference(_.map(outboundCosts, "type"), _.map(sellerConfig, "outboundCostType")).length > 0) {
        const usagePercentage = _.round(1 / outboundCosts.length, 5);
        return _.reduce(outboundCosts, (result, cost) => {
            result[cost.type] = { usagePercentage, costs: cost.costs };
            return result;
        }, {});
    }
    return _.reduce(outboundCosts, (result, cost) => {
        const usagePercentage = _.find(sellerConfig, {
            outboundCostType: cost.type,
        }).pct;
        result[cost.type] = { usagePercentage, costs: cost.costs };
        return result;
    }, {});
}
exports.createOutboundCostsByUsagePercentage = createOutboundCostsByUsagePercentage;
//# sourceMappingURL=OutboundCostUtils.js.map